export default "__VITE_ASSET__Cq20GY5s__"